import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckOutForm from "./CheckOutForm";
import { url } from "../../baseUrl";

export default function StripeCardForm({
  transactionId,
  amount,
  account,
  stripeKey,
}) {
  const [clientSecret, setClientSecret] = useState("");

  useEffect(() => {
    // 🚀 USD to GBP conversion rate (1 USD = 0.78 GBP approx)
    // Aap real-time rate bhi use kar sakte ho
    const usdToGbpRate = 0.78;
    const amountInGBP = Math.round(amount * usdToGbpRate * 100) / 100;
    
    console.log("Original Amount (USD):", amount);
    console.log("Converted Amount (GBP):", amountInGBP);
    console.log("Account:", account);
    
    fetch(`${url}/stripe/create-payment-intent`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        transactionId: transactionId,
        amount: amountInGBP,  // 🔥 Converted GBP amount bhej raha hai
        account: account,
      }),
    })
      .then((res) => res.json())
      .then((data) => setClientSecret(data.clientSecret));
  }, [transactionId, amount, account]);

  const appearance = {
    theme: "stripe",
  };
  const options = {
    clientSecret,
    appearance,
  };

  return (
    <div className="App">
      {clientSecret && (
        <Elements options={options} stripe={loadStripe(`${stripeKey}`)}>
          <CheckOutForm />
        </Elements>
      )}
    </div>
  );
}